// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

/**
* 
* @param {string|array} selector selector or selectors 
* @param {function} callback callback(event, value, target)
*/
export function handleChange (selector, callback) {
    $(document).on('change', selector, (event) => {
        callback(event, (event.currentTarget.value || null), ($(event.currentTarget) || null));
    });
};

/**
* 
* @param {string|array} name name or array of names
* @param {boolean} visible Visible flag
* @param {object|null} context jQuery object
*/
export function setFormGroupVisibility(name, visible, context = null) {
    if (!Array.isArray(name)) {
        name = [name];
    }
    let selector = name.map((value) => {
        return '[data-form-group-name=' + value + ']';
    }).join(', ');
    let formGroup = $(selector, context);
    if (formGroup.length > 0) {
        formGroup.toggleClass('hidden', !visible).toggleClass('wobble', visible);
    }
};

/**
* 
* @param {string|array} name name or array of names
*/
export function resetValidation(name) {
    if (!Array.isArray(name)) {
        name = [name];
    }
    let selector = name.map((value) => {
        return '[data-form-group-name=' + value + ']';
    }).join(', ');
    $(selector).removeClass('valid', 'invalid');
};

export function updateFormGroupLabel(name, text) {
    let formGroup = $('.form-group[data-form-group-name=' + name + ']');
    if (formGroup.length === 1) {
        let formLabel = formGroup.find('label.form-label');
        formLabel.text(text);
    }
}

export function smoothScrollToElement(element) {
    $('html, body').animate(
        {
            scrollTop: element.offset().top,
        },
        500,
        'linear'
        );
    }